import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import { useAuthStore } from '../stores/auth'

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage
    },
    {
        path: '/plan/:id',
        name: 'PlanView',
        // Lazy load the plan view
        component: () => import('../views/PlanViewPage.vue')
    },
    {
        path: '/terms',
        name: 'Terms',
        component: () => import('../views/TermsOfService.vue')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import('../views/PrivacyPolicy.vue')
    },
    {
        path: '/disclaimer',
        name: 'Disclaimer',
        component: () => import('../views/DisclaimerView.vue')
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('../views/LoginPage.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: { requiresAuth: true },
        component: () => import('../views/ProfilePage.vue')
    },
    {
        path: '/setup',
        name: 'Onboarding',
        meta: { requiresAuth: true },
        component: () => import('../views/OnboardingPage.vue')
    },
    {
        path: '/stats',
        name: 'Stats',
        meta: { requiresAuth: true },
        component: () => import('../views/StatsPage.vue')
    },
    {
        path: '/settings',
        name: 'Settings',
        meta: { requiresAuth: true },
        component: () => import('../views/SettingsPage.vue')
    },
    {
        path: '/upgrade',
        name: 'Upgrade',
        component: () => import('../views/UpgradePage.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore();
    authStore.init();

    // Wait for auth to settle
    await authStore.waitForAuth();

    if (to.meta.requiresAuth && !authStore.isAuthenticated) {
        next({ name: 'Login', query: { redirect: to.fullPath } });
        return;
    }

    if (to.name === 'Login' && authStore.isAuthenticated) {
        next({ name: 'Profile' });
        return;
    }

    next();
});

export default router
